import { render, staticRenderFns } from "./DeleteCourseCategoryConfirmation.vue?vue&type=template&id=384256e7"
import script from "./DeleteCourseCategoryConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteCourseCategoryConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports